var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('PagedTable',{attrs:{"title":"Categories","headers":_vm.headers,"feathersModel":_vm.$FeathersVuex.Category},on:{"onCreate":function($event){_vm.dialog='true'}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }